import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { PeopleNotificationsShape, UserShape } from '../../shapes';
import DateMaster from '../../stores/utils/date_master';
import Waiting from '../waiting';
import TackLikeButton from '../tack_like_button';
import verified from '../../images/verified-blue.svg';
import PropTypes from 'prop-types';

export default class PeopleBoardNotifications extends React.Component {

  static propTypes = {
    user: UserShape,
    peopleNotifications: PeopleNotificationsShape,
    onLoadPeopleNotifications: PropTypes.func,
    onMarkAsRead: PropTypes.func,
    onMarkAllAsRead: PropTypes.func,
    onLikeTack: PropTypes.func,
    onUnLikeTack: PropTypes.func
  }

  componentDidMount() {
    this.props.onLoadPeopleNotifications();
  }

  render() {
    let boardContent = null;
    if (this.props.peopleNotifications.get('loading')) {
      boardContent = this.renderLoading.bind(this);
    } else if (this.props.peopleNotifications.get('notifications').size == 0) {
      boardContent = this.renderNoNotifications.bind(this);
    } else {
      boardContent = this.renderReadAndUnread.bind(this);
    }
    return boardContent()
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }

  renderNoNotifications() {
    let buttonContent;
    if (this.props.user.get('followsCount') > 0) {
      buttonContent = 'Follow more people';
    } else {
      buttonContent = 'Start following people'
    }

    return (
      <div className='no-notifications'>
        <h4>No notifications on the People Board yet.</h4>
        <div className='action'>
          <Link to='/account/recommend_people_to_follow' className='btn btn-dark'>{ buttonContent }</Link>
        </div>
      </div>
    )
  }

  renderReadAndUnread() {
    return (
      <Fragment>
        { this.renderUnreadPeopleNotifications() }
        { this.renderReadPeopleNotifications() }
      </Fragment>
    )
  }

  renderUnreadPeopleNotifications() {
    const unreadPeopleNotifications = this.props.peopleNotifications.get('notifications')
      .filter(peopleNotification => !peopleNotification.get('readAt'))
      .map((peopleNotification, i) => {
        return this.renderPeopleNotification(peopleNotification, `unread-${i}`, false);
    });
    if (unreadPeopleNotifications.size > 0) {
      return (
        <div className='board-notification-group'>
          <div className='secondary-background instruction-text'>
            <Link className='small-board-action' to='#' onClick={ event => this.onMarkAllAsRead(event) }>Mark all as read</Link>
          </div>
          <ul className='list-group'>{ unreadPeopleNotifications }</ul>
        </div>
      );
    } else return null;
  }

  renderReadPeopleNotifications() {
    const readPeopleNotifications = this.props.peopleNotifications.get('notifications')
      .filter(peopleNotification => peopleNotification.get('readAt'))
      .map((peopleNotification, i) => {
        return this.renderPeopleNotification(peopleNotification, `read-${i}`, true);
    });
    if (readPeopleNotifications.size > 0) {
      return (
        <div className='board-notification-group'>
          <ul className='list-group'>{ readPeopleNotifications }</ul>
        </div>
      );
    } else return null;
  }

  renderPeopleNotification(peopleNotification, i, isRead) {
    const classNames = (isRead) ? 'list-group-item secondary-background' : ' list-group-item list-group-item-action';
    if (peopleNotification.get('peopleNotifiableType') === 'UserFollow') {
      return (
        <li key={ i } className={ classNames }>
          { this.renderNewFollowerNotification(peopleNotification) }
        </li>
      );
    } else if (peopleNotification.get('peopleNotifiableType') === 'Tack') {
      return (
        <li key={ i } className={ classNames }>
          { this.renderNewWordFromFollowerNotification(peopleNotification) }
        </li>
      );
    } else if (peopleNotification.get('peopleNotifiableType') === 'Comment') {
      return (
        <li key={ i } className={ classNames }>
          { this.renderNewCommentFromFollowerNotification(peopleNotification) }
        </li>
      );
    } else if (peopleNotification.get('peopleNotifiableType') === 'CommentLike') {
      return (
        <li key={ i } className={ classNames }>
          { this.renderCommentLikedNotification(peopleNotification) }
        </li>
      );
    } else if (peopleNotification.get('peopleNotifiableType') === 'CommentMention') {
      return (
        <li key={ i } className={ classNames }>
          { this.renderNewMentionInCommentNotification(peopleNotification) }
        </li>
      )
    } else {
      return null;
    }
  }

  renderNewWordFromFollowerNotification(peopleNotification) {
    return (
      <div>
        <Link className='link-with-no-border' to={ `/words/${ peopleNotification.get('peopleNotifiableSlug') }` } onClick={ () => this.props.onMarkAsRead(peopleNotification.get('slug')) }>
          { this.renderTriggeredByDisplayName(peopleNotification) } started tacking <b>{ peopleNotification.get('peopleNotifiableSlug') }</b>.
        </Link>
        <div className='item-meta'>
          <div>
            { `${ DateMaster.timeSince(peopleNotification.get('createdAt')) } ago` }
          </div>
          <div className='like-top-spacer'>
            <TackLikeButton tackId={ peopleNotification.get('peopleNotifiableId') } user={ this.props.user } likedBy={ peopleNotification.get('likedBy') } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } />
          </div>
        </div>
      </div>
    )
  }

  renderNewFollowerNotification(peopleNotification) {
    return (
      <Link to={ `/people/${ peopleNotification.get('peopleNotifiableSlug') }` } onClick={ () => this.props.onMarkAsRead(peopleNotification.get('slug')) }>
        <div>
          <b>{ this.renderTriggeredByDisplayName(peopleNotification) }</b> started following you.
          <p className='item-meta'>{ `${ DateMaster.timeSince(peopleNotification.get('createdAt')) } ago` }</p>
        </div>
      </Link>
    )
  }

  renderNewCommentFromFollowerNotification(peopleNotification) {
    return (
      <Link to={ `/words/${ peopleNotification.get('peopleNotifiableSlug') }` } onClick={ () => this.props.onMarkAsRead(peopleNotification.get('slug')) }>
        <div>
          { this.renderTriggeredByDisplayName(peopleNotification) } added to the discussion on the word <b>{ peopleNotification.get('peopleNotifiableSlug') }</b>.
          <p className='item-meta'>{ `${ DateMaster.timeSince(peopleNotification.get('createdAt')) } ago` }</p>
        </div>
      </Link>
    )
  }

  renderNewMentionInCommentNotification(peopleNotification) {
    return (
      <Link to={ `/words/${ peopleNotification.get('peopleNotifiableSlug') }` } onClick={ () => this.props.onMarkAsRead(peopleNotification.get('slug')) }>
        <div>
          { this.renderTriggeredByDisplayName(peopleNotification) } mentioned you in the discussion on the word <b>{ peopleNotification.get('peopleNotifiableSlug') }</b>.
          <p className='item-meta'>{ `${ DateMaster.timeSince(peopleNotification.get('createdAt')) } ago` }</p>
        </div>
      </Link>
    )
  }

  renderCommentLikedNotification(peopleNotification) {
    return (
      <Link to={ `/words/${ peopleNotification.get('peopleNotifiableSlug') }` } onClick={ () => this.props.onMarkAsRead(peopleNotification.get('slug')) }>
        <div>
          { this.renderTriggeredByDisplayName(peopleNotification) } liked your comment on the word <b>{ peopleNotification.get('peopleNotifiableSlug') }</b>.
          <p className='item-meta'>{ `${ DateMaster.timeSince(peopleNotification.get('createdAt')) } ago` }</p>
        </div>
      </Link>
    )
  }

  renderTriggeredByDisplayName(peopleNotification) {
    if (peopleNotification.get('triggeredByUserHasActiveSubscription')) {
      return (
        <Fragment>
          { peopleNotification.get('triggeredByUserName') } 
          <span className='verified-mark-15-inline'>
            <img src={verified} alt='Verified and Unlimited' />
          </span>
        </Fragment>
      )
    } else {
      return peopleNotification.get('triggeredByUserName');
    }
  }

  onMarkAllAsRead(event) {
    event.preventDefault();
    this.props.onMarkAllAsRead();
  }
}



// WEBPACK FOOTER //
// ./src/components/people_board/people_board_notifications.jsx